var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSourcing = function SvgSourcing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sourcing_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.939 3.354.146 5.146A.5.5 0 0 0 .5 6h5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.854-.354L3.354 1.939 1.707.293A1 1 0 0 0 .293 1.707zM8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4m7.5-4h-5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .854-.354l1.792 1.793L14.293.293a1 1 0 0 1 1.414 1.414l-1.646 1.647 1.793 1.792A.5.5 0 0 1 15.5 6m-1.439 6.646 1.793-1.792A.5.5 0 0 0 15.5 10h-5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .854.354l1.792-1.793 1.647 1.646a1 1 0 0 0 1.414-1.414zM.5 10h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.854.354l-1.792-1.793-1.647 1.646a1 1 0 1 1-1.414-1.414l1.646-1.647-1.793-1.792A.5.5 0 0 1 .5 10",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sourcing_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgSourcing;